import { PaginatedListResponse } from "@/domain/dto/BaseDataResponse";
import { BaseListQueryParamsDTO } from "@/domain/dto/BaseQueryParamsDTO";
import { ListPartnerQueryParamsDTO } from "@/domain/dto/ListPartnerQueryParamsDTO";
import { Partner } from "@/domain/entities/Partner";
import { IPartnerRepository } from "@/domain/repositories/IPartnerRepository";
import { IListPartnersUseCase } from "@/domain/usecases/IListPartnersUseCase";

export class ListPartnersUseCase implements IListPartnersUseCase {
    repository: IPartnerRepository
    constructor(repository: IPartnerRepository) {
        this.repository = repository
    }
    execute(params: ListPartnerQueryParamsDTO): Promise<PaginatedListResponse<Partner>> {
        return this.repository.list(params)
    }

}